import React, { Component } from 'react';
import { Container, Row, Col, Form, Image, Button, Dropdown, DropdownButton,FormControl} from 'react-bootstrap';
import ReactNotification from 'react-notifications-component';
import NumberFormat from 'react-number-format';



import '../index.css'
import Card from '../../../Images/Ejemplo_Tarjeta.png'

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import icons from '../../Landing/icons.json'


export default class CardView extends Component {
    constructor(props){
        super(props)
        this.state = {
          text:''
        }
    }

    componentDidMount(){

        // requested disabled payment sent enabled blocked
        switch(this.props.status){
            case 'requested':
                this.setState({text:'Your request is being processed.'})
                break;
            case 'payment':
                this.setState({text:'Waiting for payment.'})
                break;
            case 'sent':
                this.setState({text:'Your card has been sent, wait for it'})
                break;
            default :
                this.setState({text:''})
                break;
        }
    }

    render(){
        return(

            <div>
            <div className="contenedor-wallets-generals">
                <Container fluid>
                <Row>
                    <Col lg={{span:10, offset:1}}>
                    <div className='container-withouth-data-wallets'>
                        <p className="title-withouth-data-wallets">{this.state.text}</p>
                    </div>
                    </Col>
                </Row>
                </Container>
            </div>
            </div>
        )
    }
}
